import { useContext } from 'react';
import { ThemeContext, ThemeContextValue } from './theme-context';
import { DEFAULT_THEME } from './constants';
import { resolveTheme } from './resolve-theme';

const fallback: ThemeContextValue = {
  theme: DEFAULT_THEME,
  resolvedTheme: resolveTheme(DEFAULT_THEME),
  setTheme: () => undefined,
};

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext) || fallback;
}
